// ── 언어(한국어/영어) 선택 공용 유틸 ─────────────────────────────────────
//
// 지금까지는 언어 선택이 브라우저 localStorage에만 저장돼서, 기기/브라우저를
// 바꾸면 매번 다시 선택해야 했다. 이제 로그인한 사용자가 언어를 바꾸면 계정에도
// 저장되어(백엔드 PUT /api/auth/language) 어디서 로그인하든 그대로 유지된다.
// 로그인하지 않은 화면(등록 폼 등 공개 페이지)에서는 브라우저에만 저장한다.

import axios from 'axios';
import i18n from '../i18n';

export function setLanguage(lang, { persistToAccount = true } = {}) {
  i18n.changeLanguage(lang);
  try { localStorage.setItem('lang', lang); } catch {}

  if (!persistToAccount) return;
  const token = localStorage.getItem('access_token') || localStorage.getItem('token');
  if (!token) return; // 로그인 안 한 상태(등록 폼 등)면 계정에 저장할 게 없음

  axios.put('/api/auth/language', { language: lang },
    { headers: { Authorization: `Bearer ${token}` } }
  ).catch(() => {}); // 저장 실패해도 화면은 이미 바뀐 상태라 조용히 무시 (다음 로그인 때 다시 시도됨)

  try {
    const cached = JSON.parse(localStorage.getItem('user') || '{}');
    if (cached && typeof cached === 'object') {
      cached.preferred_language = lang;
      localStorage.setItem('user', JSON.stringify(cached));
    }
  } catch {}
}

// 로그인 직후나 앱 시작 시, 계정에 저장된 언어(없으면 소속 교회 기본 언어)로
// i18n을 맞춰준다. 이미 그 언어면 아무 것도 안 함(화면 깜빡임 방지).
export function applyAccountLanguage(user) {
  if (!user) return;
  const lang = user.preferred_language || user.church?.default_language;
  if (lang && (lang === 'ko' || lang === 'en') && i18n.language !== lang) {
    i18n.changeLanguage(lang);
    try { localStorage.setItem('lang', lang); } catch {}
  }
}

// 비로그인 공개 페이지(등록 폼 등)에서, 방문자가 이 브라우저에서 아직 한 번도
// 언어를 직접 고른 적이 없으면(=localStorage에 'lang'이 없으면) 그 교회의 기본
// 언어로 초기 표시한다. 이미 방문자가 스스로 고른 언어가 있으면 존중하고 덮어쓰지 않는다.
export function applyChurchDefaultLanguageIfUnset(church) {
  if (!church?.default_language) return;
  let already;
  try { already = localStorage.getItem('lang'); } catch { already = null; }
  if (!already && (church.default_language === 'ko' || church.default_language === 'en')) {
    i18n.changeLanguage(church.default_language);
  }
}

// msg: 백엔드가 내려주는 { ko, en } 형태의 메시지 객체 (또는 그냥 문자열).
// en이 아직 없는 메시지가 많아서, en 선택 시에도 en이 없으면 ko로 자연스럽게 대체한다.
export function pickMsg(msg, lang) {
  if (!msg) return '';
  if (typeof msg === 'string') return msg;
  return (lang === 'en' ? msg.en : msg.ko) || msg.ko || msg.en || '';
}
